class AllItemsRequest {
  /** lifecycleStatus */
  lifecycleStatus = "";

  /** limit */
  limit = "";

  /** nextCursor */
  nextCursor = "";

  /** offset */
  offset = "";

  /** publishedStatus */
  publishedStatus = "";

  /** sku */
  sku = "";
}

class AllOrdersRequest {
  /** createdEndDate */
  createdEndDate = "";

  /** createdStartDate */
  createdStartDate = "";

  /** customerOrderId */
  customerOrderId = "";

  /** fromExpectedShipDate */
  fromExpectedShipDate = "";

  /** lastModifiedEndDate */
  lastModifiedEndDate = "";

  /** lastModifiedStartDate */
  lastModifiedStartDate = "";

  /** limit */
  limit = "";

  /** orderType */
  orderType = "";

  /** productInfo */
  productInfo = "";

  /** purchaseOrderId */
  purchaseOrderId = "";

  /** replacementInfo */
  replacementInfo = "";

  /** shipNodeType */
  shipNodeType = "";

  /** shippingProgramType */
  shippingProgramType = "";

  /** sku */
  sku = "";

  /** status */
  status = "";

  /** toExpectedShipDate */
  toExpectedShipDate = "";
}

class ChargeAmountBean {
  /** amount */
  amount = undefined;

  /** currency */
  currency = "";
}

class ChargeBean {
  /** chargeAmount */
  chargeAmount = new ChargeAmountBean();

  /** chargeName */
  chargeName = "";

  /** chargeType */
  chargeType = "";

  /** tax */
  tax = new TaxBean();
}

class CreateSubscriptionsRequest {
  /** events */
  events = [];
}

class EventsBean {
  /** authDetails */
  authDetails = new SubscriptionsAuthDetails();

  /** eventType */
  eventType = "";

  /** eventUrl */
  eventUrl = "";

  /** eventVersion */
  eventVersion = "";

  /** headers */
  headers = new SubscriptionsHeaders();

  /** resourceName */
  resourceName = "";

  /** status */
  status = "";
}

class OptionalShippingRpcMethodDto {
  /** 是否申请多渠道订单 1:是 0:否 */
  optionalIsMcf = undefined;

  /** 自选物流渠道 */
  optionalLogisticsChannel = "";

  /** 自选物流渠道编码 */
  optionalLogisticsChannelCode = "";

  /** 自选物流商 */
  optionalLogisticsCompany = "";

  /** 自选物流商编码 */
  optionalLogisticsCompanyCode = "";

  /** 自选发货仓库 */
  optionalLogisticsDeliveryWarehouse = "";

  /** 自选发货仓库编码 */
  optionalLogisticsDeliveryWarehouseCode = "";
}

class OrderLineBean {
  /** lineNumber */
  lineNumber = "";

  /** refunds */
  refunds = new RefundsBean();
}

class OrderLinesBean {
  /** orderLine */
  orderLine = [];
}

class OrderRefundBean {
  /** orderLines */
  orderLines = new OrderLinesBean();

  /** purchaseOrderId */
  purchaseOrderId = "";
}

class OrderRefundRequest {
  /** orderRefund */
  orderRefund = new OrderRefundBean();
}

class PayloadBean {
  /** customerOrderId */
  customerOrderId = "";

  /** estimatedDeliveryDate */
  estimatedDeliveryDate = "";

  /** estimatedShipDate */
  estimatedShipDate = "";

  /** orderDate */
  orderDate = "";

  /** orderLines */
  orderLines = [];

  /** partnerId */
  partnerId = "";

  /** purchaseOrderId */
  purchaseOrderId = "";

  /** shipNodeType */
  shipNodeType = "";
}

class QuantityBean {
  /** measurementValue */
  measurementValue = "";

  /** unitOfMeasure */
  unitOfMeasure = "";
}

class RedirectSubscriptionsOrderResponse {
  /** payload */
  payload = new PayloadBean();

  /** source */
  source = new SourceBean();
}

class RefundBean {
  /** refundCharges */
  refundCharges = new RefundChargesBean();

  /** refundComments */
  refundComments = "";
}

class RefundChargeBean {
  /** charge */
  charge = new ChargeBean();

  /** refundReason */
  refundReason = "";
}

class RefundChargesBean {
  /** refundCharge */
  refundCharge = [];
}

class RefundsBean {
  /** refund */
  refund = [];
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new SystemOrderMqDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ReturnsRequest {
  /** customerOrderId */
  customerOrderId = "";

  /** limit */
  limit = "";

  /** replacementInfo */
  replacementInfo = "";

  /** returnCreationEndDate */
  returnCreationEndDate = "";

  /** returnCreationStartDate */
  returnCreationStartDate = "";

  /** returnLastModifiedEndDate */
  returnLastModifiedEndDate = "";

  /** returnLastModifiedStartDate */
  returnLastModifiedStartDate = "";

  /** returnOrderId */
  returnOrderId = "";

  /** returnType */
  returnType = "";

  /** status */
  status = "";
}

class SourceBean {
  /** eventId */
  eventId = "";

  /** eventTime */
  eventTime = "";

  /** eventType */
  eventType = "";
}

class SubscriptionsAuthDetails {
  /** authHeaderName */
  authHeaderName = "";

  /** authMethod */
  authMethod = "";

  /** authUrl */
  authUrl = "";

  /** clientId */
  clientId = "";

  /** clientSecret */
  clientSecret = "";

  /** password */
  password = "";

  /** userName */
  userName = "";
}

class SubscriptionsHeaders {
  /** content-type */
  "content-type" = "";
}

class SystemOrderDto {
  /** 买家ID/编号 */
  buyerCode = "";

  /** 买家邮箱 */
  buyerEmail = "";

  /** 买家留言 */
  buyerMessage = "";

  /** 买家指定物流 */
  buyerSpecifyLogistics = "";

  /** 客户id */
  customerId = "";

  /** 客户名称 */
  customerName = "";

  /** 折扣码 */
  discountCode = "";

  /** 物流运费 */
  logisticsShipping = undefined;

  /** 订单付款方式 */
  payMethod = "";

  /** 收件人地址1 */
  shippingAddress1 = "";

  /** 收件人地址2 */
  shippingAddress2 = "";

  /** 收件人城市 */
  shippingCity = "";

  /** 收件人所在国家 */
  shippingCountry = "";

  /** 收件人所在国家编码 */
  shippingCountryCode = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人名字 */
  shippingName = "";

  /** 收件人电话 */
  shippingPhone = "";

  /** 收件人邮编 */
  shippingPostCode = "";

  /** 收件人州或省 */
  shippingStateOrProvince = "";

  /** 收件人州或省编码 */
  shippingStateOrProvinceCode = "";

  /** 收件人纳税号 */
  shippingTaxid = "";

  /** 贸易主体编码 */
  soTradeCompanyCode = "";

  /** 贸易主体名称 */
  soTradeCompanyName = "";

  /** 平台订单佣金 */
  spCommission = undefined;

  /** 平台订单币种 */
  spCurrency = "";

  /** 平台订单优惠额 */
  spDiscount = undefined;

  /** 平台订单店铺 */
  spMarketCode = "";

  /** 平台订单店铺名称 */
  spMarketName = "";

  /** 平台订单id（平台生成） */
  spOrderId = "";

  /** 平台订单号（客服填写,如果没有则等于spOrderId） */
  spOrderNo = "";

  /** 订单付款状态 */
  spOrderPayStatus = "ACCOUNT_PAID";

  /** 订单状态 */
  spOrderStatus = "CANCELED";

  /** 平台订单下单时间 */
  spOrderTime = "";

  /** 平台订单更新时间 */
  spOrderUpdateTime = "";

  /** 平台订单实收款 */
  spPayAmount = undefined;

  /** 平台订单支付时间 */
  spPaymentDate = "";

  /** 平台订单来源平台 */
  spPlatform = "";

  /** 平台订单退款金额 */
  spRefundAmount = undefined;

  /** 平台订单备注 */
  spRemark = "";

  /** 平台订单销售价 */
  spSalesPrice = undefined;

  /** 平台订单运费 */
  spShipping = undefined;

  /** 平台订单发货状态 1未发货 2部分发货 3已发货 */
  spShippingStatus = undefined;

  /** 平台订单状态 */
  spStatus = "";

  /** 平台订单税费 */
  spTaxes = undefined;

  /** 平台订单交易价 */
  spTradingPrice = undefined;

  /** 交易ID */
  transactionId = "";

  /** 是否沃尔玛自营订单 */
  walMartSelfSupportOrder = false;
}

class SystemOrderItemDto {
  /** 佣金 */
  commission = undefined;

  /** 优惠价 */
  discount = undefined;

  /** 商品销售价格 */
  itemPrice = undefined;

  /** 商品价格的税费 */
  itemTax = undefined;

  /** 商品总价格 */
  itemTotalPrice = undefined;

  /** 商品交易价格 */
  itemTradingPrice = undefined;

  /** 销售sku（平台生成） */
  platformSku = "";

  /** 销售sku名字 */
  platformSkuName = "";

  /** 销售sku标题 */
  platformSkuTitle = "";

  /** 购买数量 */
  quantity = undefined;

  /** 平台订单商品编号 */
  spItemNo = "";

  /** 平台商品发货状态,平台商品发货状态 1未发货 2已发货 */
  spItemShipping = undefined;

  /** 平台商品退款金额 */
  spRefundAmount = undefined;

  /** 平台商品退货数量 */
  spReturnNumber = undefined;
}

class SystemOrderMqDto {
  /** 货运方式 */
  optionalShippingRpcMethodDto = new OptionalShippingRpcMethodDto();

  /** 推送时间 */
  sendDate = "";

  /** 订单数据 */
  systemOrderDto = new SystemOrderDto();

  /** 订单商品数据 */
  systemOrderItemDtos = [];
}

class TaxAmountBean {
  /** amount */
  amount = undefined;

  /** currency */
  currency = "";
}

class TaxBean {
  /** taxAmount */
  taxAmount = new TaxAmountBean();

  /** taxName */
  taxName = "";
}

class WalmartOrderRefundItemRequestDto {
  /** 金额 */
  amount = undefined;

  /** 币种 */
  currency = "";

  /** 退款备注 */
  note = "";

  /** 平台订单商品号(平台订单行) */
  orderLine = "";

  /** 数量,用于确认订单行 */
  qty = undefined;

  /** sku */
  sku = "";
}

class WalmartOrderRefundRequestDto {
  /** 采购订单号 */
  purchaseOrderId = "";

  /** 退款类型 */
  refundType = undefined;

  /** 店铺编码 */
  shopCode = "";

  /** 退款订单详情 */
  walmartOrderRefundItemRequestDtoList = [];
}

class WalmartOrderShippingDto {
  /** 发运商品行 */
  lineItems = [];

  /** 包裹单号 */
  opNo = "";

  /** 店铺编码 */
  shopCode = "";

  /** 中台的唯一单号标识,对应walmart是shopKey_customerOrderId_purchaseOrderId */
  spOrderId = "";

  /** 物流名称 */
  trackingCompany = "";

  /** 物流运单号 */
  trackingNumber = "";

  /** 物流轨迹查询地址 */
  trackingUrl = "";
}

class WalmartOrderShippingItemDto {
  /** 数量 */
  quantity = undefined;

  /** 商品sku */
  sku = "";
}

class WalmartProductRequestDto {
  /** 产品id */
  productId = "";

  /** 产品类型,UPC,GTIN,SKU,ITEM_ID */
  productIdType = "WM_GTIN";

  /** 产品名称,如需要搜标题,仅需传店铺编码和产品名称 */
  productName = "";

  /** 店铺编号 */
  shopCode = "";
}

class WalmartProductSearchDto {
  /** 该产品售价 */
  amount = undefined;

  /** 币种 */
  currency = "";

  /** gtin码 */
  gtin = "";

  /** 沃尔玛item_id */
  itemId = "";

  /** 生命周期状态 */
  lifeCycleStatus = "";

  /** 市场 */
  mart = "";

  /** 店铺编号 */
  platformShopCode = "";

  /** 店铺名称 */
  platformShopName = "";

  /** 产品名 */
  productName = "";

  /** 产品类型 */
  productType = "";

  /** 发布状态 */
  publishedStatus = "";

  /** sku */
  sku = "";

  /** upc */
  upc = "";

  /** wpid */
  wpid = "";
}

export const walmart = {
  AllItemsRequest,
  AllOrdersRequest,
  ChargeAmountBean,
  ChargeBean,
  CreateSubscriptionsRequest,
  EventsBean,
  OptionalShippingRpcMethodDto,
  OrderLineBean,
  OrderLinesBean,
  OrderRefundBean,
  OrderRefundRequest,
  PayloadBean,
  QuantityBean,
  RedirectSubscriptionsOrderResponse,
  RefundBean,
  RefundChargeBean,
  RefundChargesBean,
  RefundsBean,
  Response,
  ResponseDto,
  ReturnsRequest,
  SourceBean,
  SubscriptionsAuthDetails,
  SubscriptionsHeaders,
  SystemOrderDto,
  SystemOrderItemDto,
  SystemOrderMqDto,
  TaxAmountBean,
  TaxBean,
  WalmartOrderRefundItemRequestDto,
  WalmartOrderRefundRequestDto,
  WalmartOrderShippingDto,
  WalmartOrderShippingItemDto,
  WalmartProductRequestDto,
  WalmartProductSearchDto,
};
